import { frontendURL } from '../../../../helper/URLHelper';

export const routes = [
    'boards',
    'board_status',
    'board_teams',
    'board_inboxes',
    'board_filter_team',
    'board_filter_label',
    'board_filter_inbox',
    'board_filter_status',
    'board_conversations_through_board_type',
    'board_conversations_through_label',
    'board_conversation_through_inbox',
    'board_conversations_through_team',
    'board_inbox_conversation',
    'board_conversations_through_status',
  ]

const boards = accountId => ({
  parentNav: 'boards',
  routes,
  menuItems: [
    {
      label: 'BOARD_TEAM',
      key: 'board_teams',
      toState: frontendURL(`accounts/${accountId}/board-teams`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'board_teams',
    },
    {
      label: 'BOARD_STATUS',
      key: 'board_status',
      toState: frontendURL(`accounts/${accountId}/board-status`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'board_status',
    },    
    {
      label: 'BOARD_INBOX',
      key: 'board_inboxes',
      toState: frontendURL(`accounts/${accountId}/board-inboxes`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'board_inboxes',
    }
  ],
});

export default boards;
